/* eslint-disable max-len */
import { shimRequireLoad, addLibs } from 'ccui-shared/legacy-dep-bootstrap/patch-legacy-require';
import { getDefaultExport } from '@bingads-webui-cc-react/ccui-dynamic-import';

const shimLegacyModules = () => {
  shimRequireLoad('root');
  addLibs(
    // requirejs shim libs
    {
      '@bingads-webui/cldr-data-loader': () => import(/* webpackChunkName: "app" */ '@bingads-webui/cldr-data-loader'),
      '@bingads-webui-clientcenter/config': () => import('@bingads-webui-clientcenter/config'),
      '@bingads-webui-clientcenter/coupon-lightbox': () => import(/* webpackMode: 'eager' */ '../ccui-shared/dynamic-import/coupon-lightbox').then(getDefaultExport),
      '@bingads-webui-clientcenter/global-apps': () => import('@bingads-webui-clientcenter/global-apps'),
      '@bingads-webui-clientcenter/inline-alert': () => import(/* webpackChunkName: "inline-alert" */ '@bingads-webui-clientcenter/inline-alert'),
      '@bingads-webui-clientcenter/js-data-cc-rest': () => import(/* webpackChunkName: 'app' */ '@bingads-webui-clientcenter/js-data-cc-rest'),
      '@bingads-webui-clientcenter/lightbox': () => import(/* webpackChunkName: "ccui-signup" */ '@bingads-webui-clientcenter/lightbox'),
      '@bingads-webui-react/copilot-utils': () => import(/* webpackChunkName: "support-modal" */ '@bingads-webui-react/copilot-utils'),
      '@bingads-webui-react/ms-support-chat-modal': () => import(/* webpackChunkName: "support-modal" */ '@bingads-webui-react/ms-support-chat-modal'),
      '@bingads-webui-react/request-call-modal': () => import(/* webpackChunkName: "support-modal" */ '@bingads-webui-react/request-call-modal'),
      '@bingads-webui-universal/i18n-model': () => import(/* webpackChunkName: "app" */ '@bingads-webui-universal/i18n-model'),
      'component/config/index': () => import('@bingads-webui-clientcenter/config'),
      'core/i18n': () => import('core/i18n'),
      'core/txt': () => import('core/txt'),
      'instrumentation/log': () => import('instrumentation/log'),
      'legacy/ccui-activateuser': () => import(/* webpackChunkName: "ccui-activateuser" */ 'legacy/ccui-activateuser'),
      'legacy/ccui-forgotpassword': () => import(/* webpackChunkName: "ccui-forgotpassword" */ 'legacy/ccui-forgotpassword'),
      'legacy/ccui-fraudappeal': () => import(/* webpackChunkName: "ccui-fraudappeal" */ 'legacy/ccui-fraudappeal'),
      'legacy/ccui-msamigration': () => import(/* webpackChunkName: "ccui-msamigration" */ 'legacy/ccui-msamigration'),
      'legacy/ccui-mysettings': () => import(/* webpackChunkName: "ccui-mysettings" */ 'legacy/ccui-mysettings'),
      'legacy/ccui-signup': () => import(/* webpackChunkName: "ccui-signup" */ 'legacy/ccui-signup'),
      'lib/bluebird': () => import('bluebird'),
      'lib/jquery': () => import('jquery'),
      'lib/json': () => import(/* webpackMode: 'eager' */ 'imports-loader?define=>window.define!requirejs-plugins/src/json'),
      'lib/knockout': () => import('knockout'),
      'lib/react': () => import(/* webpackChunkName: "vendor.async" */ 'react'),
      'lib/react-dom': () => import(/* webpackChunkName: "vendor.async" */ 'react-dom'),
      'lib/underscore': () => import('underscore'),
      PageContext: () => import('PageContext'),
      text: () => import(/* webpackMode: 'eager' */ 'imports-loader?define=>window.define,require=>window.require!requirejs-plugins/lib/text'),
      'tl-i18n/shared-components/ms-support-chat-modal': () => import(/* webpackChunkName: "support-modal" */ 'ccui-shared/dynamic-import/ms-support-chat-modal-i18n').then(getDefaultExport),
      'tl-i18n/shared-components/request-call-modal': () => import(/* webpackChunkName: "support-modal" */ 'ccui-shared/dynamic-import/request-call-modal-i18n').then(getDefaultExport),
    },
    // skipDefaultLoad libs
    {
      '@bingads-webui-clientcenter/global-apps': true,
      '@bingads-webui-clientcenter/js-data-cc-rest': true,
      '@bingads-webui-clientcenter/lightbox': true,
    }
  );
};

shimLegacyModules();
